import React  from 'react'

const Glossary = ({
  glossary = {}
}) => {
  
  let list = []
  for ( let key in glossary ) {
    list.push(
      <li key={key} dangerouslySetInnerHTML={ { __html: '<span>'+glossary[key].abbr+': </span>'+glossary[key].desc } }></li>
    )
  }
  return (
    <div className="sub-module">
      <div className="glossary comp">
        <h3>Glossary</h3>
        <ul>
          {list}
        </ul>
      </div>
    </div>
  )
}

export default Glossary



// WEBPACK FOOTER //
// ../app/components/gamepackage/rugby/components/Glossary.jsx